export type AuthState = {
  access_token: string,
}

const initialState: AuthState = {
  access_token: ''
}

export default initialState
